import { PlatformWizard } from '../components/wizard/PlatformWizard';

export function CreatePlatform() {
  return <PlatformWizard />;
}
